import { dispatcher, api } from 'react-structure-admin';

export const STANDARDHISTORY = 'STANDARDHISTORY';

export const STANDARDHISTORY_FILE_IMPORT = 'STANDARDHISTORY_FILE_IMPORT';
export const STANDARDHISTORY_FILE_IMPORT_FINISHED =
  'STANDARDHISTORY_FILE_IMPORT_FINISHED';

export const importFile = (file, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'standardHistories',
    actionType: STANDARDHISTORY_FILE_IMPORT,
    effect: async () => api.post(`standard-histories/import-file`, file),
    onSuccess,
    onFail: () => true
  });
};
